import React from 'react';
import { Card, CardContent, CardHeader, Typography } from '@mui/material';
import { RatingSummaryTooltip, RatingDistributionBars, RatingSummaryStarRating } from '.';

interface RatingSummaryCardProps {
  average: number;
  total: number;
  distribution: Record<number, number>;
  buildingLabel: string;
  timeLabel: string;
}

export const RatingSummaryCard = ({
  average,
  total,
  distribution,
  buildingLabel,
  timeLabel,
}: RatingSummaryCardProps) => {
  return (
    <Card sx={{ minWidth: '100%', border: 'none', boxShadow: 'none', p: 0 }} variant={'outlined'}>
      <CardHeader
        sx={{ m: 0, pb: 1, pt: 0, alignItems: 'flex-start' }}
        title={
          <Typography variant="subtitle2" sx={{ fontSize: '1rem', fontWeight: 500 }}>
            Average Star Rating
          </Typography>
        }
        subheader={
          <Typography variant="caption" sx={{ color: 'text.secondary' }}>
            Source: Feedback submissions
          </Typography>
        }
        action={<RatingSummaryTooltip buildingLabel={buildingLabel} timeLabel={timeLabel} />}
      />
      <CardContent sx={{ py: 0 }}>
        <RatingSummaryStarRating average={average} />
        <RatingDistributionBars distribution={distribution} total={total} />
      </CardContent>
    </Card>
  );
};
